<app-header *ngIf="loggedIn"></app-header>
<div class="content" role="main">
  <app-loader *ngIf="!loggedIn && !loginFail"></app-loader>
  <app-toaster-notification></app-toaster-notification>
  <app-user-role-change></app-user-role-change>
  <router-outlet *ngIf="loggedIn || loginFail"></router-outlet>
</div>


<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * page loader * * * * * * * * * * * -->
<app-loader *ngIf="loading"></app-loader>
<!-- * * * * * * * * * * page loader end * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
